import { reactive } from "vue";

export const store = reactive({
  cart: [],

  addToCart(product) {
    const existingProduct = this.cart.find(item => item.name === product.name);
    if (existingProduct) {
      existingProduct.quantity += 1; // Incrémente la quantité si le produit est déjà présent
    } else {
      this.cart.push({ ...product, quantity: 1 }); // Ajoute un nouveau produit avec une quantité de 1
    }
  },

  removeFromCart(productName) {
    this.cart = this.cart.filter(item => item.name !== productName);
  },

  clearCart() {
    this.cart = [];
  },

  get cartCount() {
    return this.cart.reduce((acc, item) => acc + item.quantity, 0);
  },
});

export const wishlistStore = reactive({
  count: 0,

  setCount(value) {
    this.count = value;
  },

  increment() {
    this.count++;
  },

  decrement() {
    if (this.count > 0) this.count--;
  },
});